import { render, staticRenderFns } from "./WarehouseList.vue?vue&type=template&id=4ba4d1bf&scoped=true&"
import script from "./WarehouseList.vue?vue&type=script&lang=js&"
export * from "./WarehouseList.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseList.vue?vue&type=style&index=0&id=4ba4d1bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba4d1bf",
  null
  
)

export default component.exports